import { render, staticRenderFns } from "./config-subtitles.vue?vue&type=template&id=5a65a67e"
import script from "./config-subtitles.vue?vue&type=script&lang=js"
export * from "./config-subtitles.vue?vue&type=script&lang=js"
import style0 from "./config-subtitles.vue?vue&type=style&index=0&id=5a65a67e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports